/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Document_PhotoInputs */

const en_inbound_document_photo = /** @type {(inputs: Inbound_Document_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photo`)
};

/**
* | output |
* | --- |
* | "Photo" |
*
* @param {Inbound_Document_PhotoInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_document_photo = /** @type {((inputs?: Inbound_Document_PhotoInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Document_PhotoInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_document_photo(inputs)
});